<template>
  <div class="baniere">
    <div class="flou" />
    <div class="bloc md:pt-24 pt-10">
      <div
        class="w-full"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="title w-full ">
          <div>Mobilisez l’intelligence collective de nos équipes</div>
          <div class="col">
            pour donner vie à vos projets.
          </div>
        </div>
      </div>
      <div
        class="md:mt-20 mt-10 pt-4"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <img
          src="../../../assets/images/webp/team.webp"
          alt="Equipe de travail"
          class=""
        >
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .flou{
    position: absolute;
    width: 897px;
    height: 578px;
    left: 0px;
    top: 0px;
    background-image: url("../../../assets/images/png/grille.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }
 img{
   position: relative;
 }
  .title{
    position: relative;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 170%;
    text-align: center;
    letter-spacing: 0.01em;
    color: $text-black-dev;
    .col{
      color: $text-rose-dev;
    }
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .title{
      font-size: 32px;
      line-height: 140%;
    }
    .flou{
      position: absolute;
      width: 407px;
      height: 358px;
      left: 0px;
      top: 0px;
      background-image: url("../../../assets/images/png/grille.png");
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .title{
      font-size: 42px;
    }
  }
</style>
